import { getGroupForType, Groups, TypeInterface } from '../Enum/Groups';
import { Solution } from '../Enum/Solution';
import { ProductInterface } from '../Model/Product';

export const GroupUri = {
    SteeringFrame: '/steering-frame',
    LinearActuator: '/linear-actuator',
    WebGuideController: '/web-guide-controller',
    TensionController: '/tension-controller',
    ForceSensor: '/force-sensor',
    Amplifier: '/amplifier',
    MaterialSensor: '/material-sensor',
    TensionAccessories: '/tension-accessories',
    WebGuideAccessories: '/web-guide-accessories',
    TelemetrySystem: '/telemetry-system',
    MeasuringRoller: '/measuring-roller',
    Electronics: '/electronics',
};

export class UriBuilder {
    public static productUri(product: ProductInterface): string | undefined {
        const webBase = `${process.env.REACT_APP_WEB_URL}`;
        const uri = product.meta.uri;
        if (!uri) {
            return undefined;
        }
        const pat = /^https?:\/\//i;
        if (pat.test(uri)) {
            return uri;
        } else {
            return webBase + uri;
        }
    }

    public static typeUri(type: TypeInterface): string {
        return this.groupUri(getGroupForType(type));
    }

    public static groupUri(group: Groups): string {
        switch (group) {
            case Groups.SteeringFrame:
                return GroupUri.SteeringFrame;
            case Groups.LinearActuator:
                return GroupUri.LinearActuator;
            case Groups.WebGuideController:
                return GroupUri.WebGuideController;
            case Groups.TensionController:
                return GroupUri.TensionController;
            case Groups.ForceSensor:
                return GroupUri.ForceSensor;
            case Groups.Amplifier:
                return GroupUri.Amplifier;
            case Groups.MaterialSensor:
                return GroupUri.MaterialSensor;
            case Groups.TensionAccessories:
                return GroupUri.TensionAccessories;
            case Groups.WebGuideAccessories:
                return GroupUri.WebGuideAccessories;
            case Groups.TelemetrySystem:
                return GroupUri.TelemetrySystem;
            case Groups.MeasuringRoller:
                return GroupUri.MeasuringRoller;
            case Groups.Electronics:
                return GroupUri.Electronics;
        }
    }

    public static solutionUri(solution: Solution): string {
        switch (solution) {
            case Solution.BeltScale:
                return GroupUri.MeasuringRoller;
            case Solution.Telemetry:
                return GroupUri.TelemetrySystem;
            case Solution.TensionControl:
                return GroupUri.ForceSensor;
            case Solution.WebGuiding:
                return GroupUri.SteeringFrame;
        }
    }
}
